import register from '@kpsys/angularjs-register';
import {thesaurusRoutes} from './thesaurus.routes';
import {KpThesaurusService} from './kp-thesaurus.service';

export default register('portaro.features.thesaurus')
    .config(thesaurusRoutes)
    .service(KpThesaurusService.serviceName, KpThesaurusService)
    .name();